var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "modal", staticClass: "modal fade", attrs: { role: "dialog" } },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("dutyDueTimespan")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.dueWeeks,
                    expression: "dueWeeks",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", min: "0" },
                domProps: { value: _vm.dueWeeks },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.dueWeeks = _vm._n($event.target.value)
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.dueDays,
                    expression: "dueDays",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  min: _vm.dueSeconds >= 3600 * 24 * 7 ? -1 : 0
                },
                domProps: { value: _vm.dueDays },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.dueDays = _vm._n($event.target.value)
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.dueHours,
                    expression: "dueHours",
                    modifiers: { number: true }
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  min: _vm.dueSeconds >= 3600 * 24 ? -1 : 0
                },
                domProps: { value: _vm.dueHours },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.dueHours = _vm._n($event.target.value)
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("btnCancel")) +
                    "\n                "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                ref: "createButton",
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.save }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("btnSave")) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }